import { render, staticRenderFns } from "./AgreementEdit.vue?vue&type=template&id=4518af93&"
import script from "./AgreementEdit.vue?vue&type=script&lang=js&"
export * from "./AgreementEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports